import type { Furniture } from "@/types/api";
import { create } from "zustand";

interface PreviewImg {
  src: string;
  name: string;
}

interface InventoryAdminUiState {
  rawSearch: string;
  search: string;
  helpOpen: boolean;
  previewImg: PreviewImg | null;
  deleteTarget: Furniture | null;
  setRawSearch: (v: string) => void;
  setSearch: (v: string) => void;
  setHelpOpen: (v: boolean) => void;
  setPreviewImg: (v: PreviewImg | null) => void;
  setDeleteTarget: (v: Furniture | null) => void;
}

export const useInventoryAdminUi = create<InventoryAdminUiState>((set) => ({
  rawSearch: "",
  search: "",
  helpOpen: false,
  previewImg: null,
  deleteTarget: null,
  setRawSearch: (rawSearch) => set({ rawSearch }),
  setSearch: (search) => set({ search }),
  setHelpOpen: (helpOpen) => set({ helpOpen }),
  setPreviewImg: (previewImg) => set({ previewImg }),
  setDeleteTarget: (deleteTarget) => set({ deleteTarget }),
}));
